

import React, {useState, useRef, useEffect} from "react";
import { PlasmicCreateNewElement } from "./plasmic/collect_wise_draft/PlasmicCreateNewElement";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

function CreateNewElement_(props, ref) {
  const navigate = useNavigate()
 
  const { showOptions, setShowOptions, checkPermission, showToast } = useAuth()
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);

  function useOutsideAlerter(ref1, ref2) {
    useEffect(() => {
   
      // Function for click event
      function handleOutsideClick(event) {
        if ((ref1.current && !ref1.current.contains(event.target)) && (ref2.current && !ref2.current.contains(event.target))) {
          setShowOptions(false)
        }
      }
   
      // Adding click event listener
      document.addEventListener("click", handleOutsideClick);
      return () => document.removeEventListener("click", handleOutsideClick);
    }, [ref1, ref2]);
  }

  useOutsideAlerter(ref1, ref2)


  return <PlasmicCreateNewElement root={{ ref
  }} {...props}
  debtButton={{
    root: {
      ref: ref1
    },
    onClick: () => {

      if(!checkPermission("Add Debtor")){
        showToast(false,"Permission Denied")
        return;
      }
      
      navigate("/submitdebts")
    }
  }}
  invoiceButton={{
    root: {
      ref: ref2
    },
    onClick: () => { 
      /*Commenting it for now as we do not have any permission for Creating Payment Link */
      // if(!checkPermission("Create Invoice")){
      //   showToast(false,"Permission Denied")
      //   return;
      // }
      navigate("/invoicesubmission")
    }
  }}
  subscriptionButton={{
    root: {
      ref: ref2
    },
    onClick: () => { 

      /*Commenting it for now as we do not have any permission for Creating Recurrent Payment */

      // if(!checkPermission("Create Invoice")){
      //   showToast(false,"Permission Denied")
      //   return;
      // }
      navigate("/subscriptionsubmission")
    }
  }}
  />;
}

const CreateNewElement = React.forwardRef(CreateNewElement_);

export default CreateNewElement;
